var map = {
	"./template.bet777": 1695,
	"./template.bet777.tsx": 1695,
	"./template.default": 264,
	"./template.default.tsx": 264,
	"./template.puntcity": 1696,
	"./template.puntcity.tsx": 1696,
	"./template.sterlingparker": 1697,
	"./template.sterlingparker.tsx": 1697,
	"./template.templebet": 1698,
	"./template.templebet.tsx": 1698,
	"./template.ts": 990
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2473;